import Vue from 'vue'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHandsWash, faDice, faBiohazard, faAllergies, faDisease, faDizzy, faProcedures, faVirus, faArrowRight, faSkullCrossbones } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHandsWash, faDice, faBiohazard, faAllergies, faDisease, faDizzy, faProcedures, faVirus, faArrowRight, faSkullCrossbones)
Vue.component('font-awesome-icon', FontAwesomeIcon)





new Vue({
  render: h => h(App),
}).$mount('#app')
